import type { ReactNode } from "react";
import { openItem } from "../lib/nav";

/** A real link (open in new tab works) that opens the item panel in place on a normal click. */
export function ItemLink({ itemKey, className, children }: { itemKey: string; className?: string; children: ReactNode }) {
  return (
    <a
      className={className}
      href={`${location.pathname}?item=${itemKey}`}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        openItem(itemKey);
      }}
    >
      {children}
    </a>
  );
}
